import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const Icon26Plus = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6001 7.12505C4.6001 6.90625 4.68702 6.6964 4.84173 6.54169C4.99645 6.38697 5.20629 6.30005 5.4251 6.30005C5.6439 6.30005 5.85374 6.38697 6.00846 6.54169C6.16318 6.6964 6.2501 6.90625 6.2501 7.12505C6.2501 7.3687 6.07795 7.669 5.9135 7.8912L4.6001 9.60005H6.2501"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 8.77505C7.75 8.99385 7.83692 9.20369 7.99164 9.35841C8.14635 9.51313 8.3562 9.60005 8.575 9.60005C8.7938 9.60005 9.00365 9.51313 9.15836 9.35841C9.31308 9.20369 9.4 8.99385 9.4 8.77505C9.4 8.55625 9.31308 8.3464 9.15836 8.19169C9.00365 8.03697 8.7938 7.95005 8.575 7.95005C8.3562 7.95005 8.14635 8.03697 7.99164 8.19169C7.83692 8.3464 7.75 8.55625 7.75 8.77505ZM7.75 8.77505V7.12505C7.75 6.90625 7.83692 6.6964 7.99164 6.54169C8.14635 6.38697 8.3562 6.30005 8.575 6.30005H9.125"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7002 7.95005H12.0002M11.3502 7.30005V8.60005"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
